import { IFetcher, IFetchRequest, ResponseTypes } from '../../interface/util';
import { IConfigAPI } from '../../interface/config';
import { IProgressPromise, IProgressPromiseGenerator } from '../../interface/promise';

function requestURL(config: IConfigAPI, mediaId: string): string {
    return config.url + config.extension.media.replace('%MEDIAID%', mediaId);
}

function request(config: IConfigAPI, authToken: string, mediaId: string): IFetchRequest {
    const req: IFetchRequest = {
        url: requestURL(config, mediaId),
        method: 'GET',
        headers: [
            { name: 'Authorization', value: `Bearer ${authToken}` },
            { name: 'Content-Type', value: 'application/json' },
        ],
        expectedResponseType: 'blob' as ResponseTypes,
    };

    return req;
}

interface IMediaResponseType {
    blob: Blob;
    none: void;
}

function getMedia<K extends keyof IMediaResponseType, V extends IMediaResponseType[K]>(
    promiser: IProgressPromiseGenerator,
    config: IConfigAPI,
    fetcher: Promise<IFetcher>,
    type: K,
    authToken: string,
    mediaId: string,
): IProgressPromise<V> {
    return promiser.promise<V>(async function (resolve, reject, progress) {
        try {
            const fetch = await fetcher;
            const promise = fetch<Blob>(request(config, authToken, mediaId));

            promise.onProgress(function (data) {
                progress(data);
            });

            const response = await promise;

            switch (type) {
                case 'blob':
                    {
                        const payload = response.payload as Blob;
                        const blob = new Blob([payload]);
                        resolve(blob as V);
                    }
                    break;

                case 'none':
                    resolve();
                    break;
            }
        } catch (error) {
            reject(error);
        }
    });
}

const module = {
    getMedia,
    request,
    requestURL,
};

export default module;
